"use client";

import { useItem } from "./useItem";
import { useSelectedItemId } from "./useSelectedItemId";

/** The POI whose details are open, resolved from the `selectedItem` param. */
export function useSelectedItem() {
  const { selectedItemId } = useSelectedItemId();
  return useItem(selectedItemId);
}
